import React, { useRef } from "react"

const YoutubeComponent = props => {
  const { url, title } = props

  const embedURL = url.replace("watch?v=", "embed/")

  const videoIframe = useRef()

  const iframeLoaded = () => {
    videoIframe.current.style.aspectRatio =
      videoIframe.current.offsetWidth / videoIframe.current.offsetHeight
    videoIframe.current.style.width = "100%"
  }

  return (
    <div>
      <iframe
        ref={videoIframe}
        onLoad={iframeLoaded}
        src={embedURL}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ border: "0" }}
      ></iframe>
    </div>
  )
}

export default YoutubeComponent
